<script lang="ts" setup>
import { useRoute } from 'vue-router';

const route = useRoute();

function getPage(path: string): string {
  switch (path) {
    case '/goals':
      return 'List';
  }
  return '';
}
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs :items="['Locations', getPage(route.path)]" />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
